import React from "react";
import { Analytics } from "@/lib/analyticsShim";

export const Label = React.forwardRef(function Label({ className = "", ...props }, ref) {
  return <label ref={ref} className={className} {...props} />;
});
